module.exports = __webpack_public_path__ + "static/media/04d.d9d97549.png";